import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

import {
    AccountApproveModel,
    AccountApproveParameter,
    CustomAccountApprove,
} from "@tSurya/Services/SurGetCustomPropertiesService";

import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<AccountApproveParameter & HasOnSuccess<AccountApproveModel>, AccountApproveModel>;

export const DispatchBeginAccountApprove: HandlerType = props => {
    props.dispatch({
        type: "Custom/AccountApprove/BeginLoadAccountApprove",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await CustomAccountApprove(props.parameter);
};

export const DispatchCompleteAccountApprove: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/AccountApprove/CompletedLoadAccountApprove",
        result: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter?.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginAccountApprove,
    RequestDataFromApi,
    DispatchCompleteAccountApprove,
    ExecuteOnSuccessCallback,
];

const accountApproveHandler = createHandlerChainRunner(chain, "AccountApproveHandler");
export default accountApproveHandler;
